import ParticipantsFeature from "../features/Participants";

export default function Participants() {
  return <ParticipantsFeature />;
}
